import { QuestionCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
import { useLocation } from "react-router-dom";
import "./MainLayout.css";
import pageTitleMap from "./pageTitleMap";

const { Title } = Typography;

const isGuid = (value) => {
  const guidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return guidRegex.test(value);
};

const PageTitle = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const lastPathSegment = pathSnippets[pathSnippets.length - 1];
  const urlHasParameter = !isNaN(lastPathSegment) || isGuid(lastPathSegment);
  var currentPath = urlHasParameter
    ? location.pathname.slice(0, location.pathname.lastIndexOf("/"))
    : location.pathname;

  var correctedPath =
    currentPath.endsWith("/") && currentPath !== "/" && currentPath.length > 1
      ? currentPath.slice(0, -1)
      : currentPath;

  var currentPage = pageTitleMap[correctedPath] ?? pageTitleMap[currentPath];

  return (
    <div className="page-title-container">
      <Title level={5} style={{ marginLeft: 32 }}>
        {currentPage != null ? (
          <div>
            {currentPage.icon} {currentPage?.name ?? "Unknown"}
          </div>
        ) : (
          <div>
            <QuestionCircleOutlined /> {currentPage?.name ?? "Unknown"}
          </div>
        )}
      </Title>
    </div>
  );
};

export default PageTitle;
